import { FC } from 'react'

import { IHistoryTableRowData } from '@/types/history.interface'

import HistoryTableHeader from './HistoryTableHeader'
import HistoryTableRow from './HistoryTableRow'

interface IHistoryTableProps {
	historyRows: IHistoryTableRowData[]
}

const HistoryTable: FC<IHistoryTableProps> = ({ historyRows }) => {
	return (
		<div>
			{/* Table header */}
			<div className='flex items-center h-14 mt-[30px] pr-3 border-b border-gray-300'>
				<HistoryTableHeader />
			</div>

			{/* Table rows */}
			<div className='flex flex-col'>
				{historyRows.map(row => (
					<HistoryTableRow key={row.key} row={row} />
				))}
			</div>
		</div>
	)
}

export default HistoryTable
